import React from 'react';
import { GameDetailsPlayersTable } from './GameDetailsPlayersTable/GameDetailsPlayersTable.tsx';
import { GameDetailsSettingsTable } from './GameDetailsSettingsTable/GameDetailsSettingsTable.tsx';
import styles from './HistoryDetails.module.scss';
export const HistoryDetails = ({ game, columnCount, onUsernameClick })=>/*#__PURE__*/ React.createElement("tr", null, /*#__PURE__*/ React.createElement("td", {
        colSpan: columnCount
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.detailsGrid
    }, /*#__PURE__*/ React.createElement(GameDetailsPlayersTable, {
        game: game,
        onUsernameClick: onUsernameClick
    }), /*#__PURE__*/ React.createElement(GameDetailsSettingsTable, {
        game: game
    }))));
